import React from 'react'
import { Button } from 'react-bootstrap'
import callapi from '../../helpers/callapi'

export default function AnnouncementListItem({ announcement, onDelete, onSend }) {
  const created = new Date(announcement.created).toLocaleString('th-TH')
  function handleDelete(id) {
    callapi({ url: `/announcements/${id}`, method: 'delete' })
      .then((res) => onDelete(id))
      .catch((err) => console.log(err))
  }
  function handleReaded(id) {
    callapi({ url: `/announcements/${id}/read`, method: 'post' }).catch((err) => console.log(err))
  }
  function handleAgain(id) {
    callapi({ url: `/announcements/${id}/send`, method: 'post' })
      .then((res) => {
        onSend(id)
      })
      .catch((err) => console.log(err))
  }
  return (
    <>
      <div className="d-flex align-items-center">
        <div className="d-flex" style={{ minWidth: '160px' }}>
          {created}
        </div>
        <div className="d-flex flex-grow-1">
          {announcement.message}{' '}
          {announcement.link && (
            <a
              className="link-primary"
              href={announcement.link}
              alt={announcement.message}
              style={{ marginLeft: '8px' }}
              rel="noreferrer"
              target="_blank"
            >
              ดูเพิ่มเติม
            </a>
          )}
        </div>
        <div className="d-flex">
          <Button variant="outline-danger" size="sm" onClick={() => handleDelete(announcement.id)}>
            ลบ
          </Button>
          <Button size="sm" className="ml-2" onClick={() => handleAgain(announcement.id)}>
            ส่งอีกครั้ง
          </Button>
        </div>
      </div>
    </>
  )
}
